import React from "react";

function SuccessIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="56"
			height="56"
			fill="none"
			viewBox="0 0 56 56"
		>
			<circle cx="27.999" cy="27.999" r="16.333" fill="#1F8268" />
			<path
				fill="#BDE9DD"
				d="M28 2a26 26 0 110 52 26 26 0 010-52zm-3.239 31.13l-5.776-5.78a2.229 2.229 0 10-3.153 3.153l7.354 7.355a2.221 2.221 0 003.154 0l15.228-15.233a2.23 2.23 0 10-3.15-3.153L24.762 33.129z"
			/>
		</svg>
	);
}

export default SuccessIcon;
